import { Client } from "@hapi/nes/lib/client";

import { showModal, hideModal } from "~/store/ducks/domain/ui/modal";

const Base64 = {
  encode(data) {
    return window.btoa(unescape(encodeURIComponent(data)));
  },
  decode(data) {
    return decodeURIComponent(escape(window.atob(data)));
  }
};

const hostUrl = () => `wss://${window.location.host}/nes`;

const initializeNes = async (config, store) => {
  if (!config.book.drm) return Promise.resolve();
  console.log("Initialize Nes");
  const client = new Client(hostUrl());
  const token = Base64.encode(`${config.profile.username}:${config.profile.wsSecret}`);

  client.onConnect = () => {
    client.message({
      type: "CONNECT",
      book: config.book.id,
      ulid: config.profile.ulid
    });
  };
/* führte bei einer schule zu Fehlern, restliches Sessioncheck-handling funktioniert weiter, aber nicht bei dieser schule/diesen ipads
  client.onDisconnect = (willReconnect, log) => {
    console.log("onDisconnect", { willReconnect, log });

    if (!willReconnect) {
      store.dispatch(showModal("SESSION_INVALID_MODAL"));
    }
  };
*/
  client.onHeartbeatTimeout = willReconnect => {
    console.log("onHeartbeatTimeout", { willReconnect });
  };

  client.onUpdate = message => {
    // console.log("NES:", message);
    switch (message.type) {
      case "SESSION_REVOKED": {
        store.dispatch(
          showModal("SESSION_REVOKED_MODAL", {
            // FIXME: use session implementation from nest-framework
            socket: client,
            book: config.book.id,
            ulid: config.profile.ulid
          })
        );
        break;
      }
      case "SESSION_INVALID": {
        store.dispatch(showModal("SESSION_INVALID_MODAL"));
        break;
      }
      case "SESSION_APPROVED": {
        store.dispatch(hideModal());
        break;
      }
      default:
        break;
    }
  };

  client.onError = err => {
    console.error("Nes Error: ", err);
    // client.disconnect();
  };

  return client.connect({
    auth: {
      headers: {
        authorization: `Basic ${token}`
      }
    },
    maxDelay: 10000,
    reconnect: true
  });
};

export { initializeNes };
